module.exports = __webpack_public_path__ + "kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTgY5KcC-wLOjAUw.0f441f4e176611d215dd.woff2";


//////////////////
// WEBPACK FOOTER
// /builds/maxmatthiessen/applications/advice4lifeweb/src/assets/fonts/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTgY5KcC-wLOjAUw.woff2
// module id = ../../../../../src/assets/fonts/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTgY5KcC-wLOjAUw.woff2
// module chunks = styles